const PREVIEW = {
  OPEN_PAGE_PREVIEWER: 'OPEN_PAGE_PREVIEWER',
  OPEN_CANVAS_PREVIEWER: 'OPEN_CANVAS_PREVIEWER',
  CLOSE_PREVIEWER: 'CLOSE_PREVIEWER',
}

export default PREVIEW



// WEBPACK FOOTER //
// ./src/store/preview/previewTypes.js